import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
const navLinks = [{
  name: 'Home',
  path: '/'
}, {
  name: 'Services',
  path: '/services'
}, {
  name: 'Portfolio',
  path: '/portfolio'
}, {
  name: 'About',
  path: '/about'
}, {
  name: 'Process',
  path: '/process'
}, {
  name: 'Contact',
  path: '/contact'
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  // Prevent scrolling when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isMobileMenuOpen]);
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-cream/90 backdrop-blur-md py-4 shadow-sm' : 'bg-transparent py-6'}`} data-id="element-69">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-70">
          <Link to="/" className="font-heading font-bold text-xl md:text-2xl text-teal z-50 relative" data-id="element-71">
            Fore River Creative Co.
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-72">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors hover:text-coral ${location.pathname === link.path ? 'text-coral' : 'text-teal'}`} data-id="element-73">
                {link.name}
              </Link>)}
            <Link to="/contact" data-id="element-74">
              <motion.button whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="bg-coral text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-coral-light transition-colors" data-id="element-75">
                Get in Touch
              </motion.button>
            </Link>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden text-teal z-50 relative p-2 -mr-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-76">
            {isMobileMenuOpen ? <XIcon size={28} data-id="element-77" /> : <MenuIcon size={28} data-id="element-78" />}
          </button>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-79">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 z-40 bg-cream pt-32 px-6 flex flex-col h-screen" data-id="element-80">
            <nav className="flex flex-col gap-6 text-center" data-id="element-81">
              {navLinks.map((link, i) => <motion.div key={link.name} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: i * 0.1
          }} data-id="element-82">
                  <Link to={link.path} className={`text-3xl font-heading font-semibold ${location.pathname === link.path ? 'text-coral' : 'text-teal'}`} data-id="element-83">
                    {link.name}
                  </Link>
                </motion.div>)}
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: navLinks.length * 0.1
          }} className="mt-8" data-id="element-84">
                <Link to="/contact" className="inline-block w-full" data-id="element-85">
                  <button className="bg-coral text-white w-full py-4 rounded-full text-lg font-semibold" data-id="element-86">
                    Start a Project
                  </button>
                </Link>
              </motion.div>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </>;
}